var _defs, _polygon, _polygon2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHideout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hideoutImage",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 506.08 545.07",
    preserveAspectRatio: "xMinYMin",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        stroke: #000;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "door_frame",
    className: "cls-1",
    points: "27.85 53.56 .53 535.56 461.53 544.56 505.53 .56 27.85 53.56"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "door_body",
    className: "cls-2",
    points: "52.53 511.56 45.53 75.56 436.53 53.56 403.53 479.56 52.53 511.56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "door_panels",
    className: "cls-2",
    d: "M202.53,140.37v109.2l-122-13.5V117.56l122,22.8Zm175.32,131.82V117.56l-90.91,19.77v112.23l90.91,22.62Zm0,62.12l-90.91-40.91-19.41,120.17,103,22,7.32-101.26ZM80.53,435.56l122,16.92,10-146.92-114.98-12.17-17.02,142.17Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideout);
export default __webpack_public_path__ + "static/media/Hideout.4cfd90cb9080483fb5232e253bcc0864.svg";
export { ForwardRef as ReactComponent };